import { DrivingStyles } from "shared-types";

export const drivingStylesOpts: {
  name: string;
  factor: number;
  id: DrivingStyles;
}[] = [
  { name: "vorrausschauend", factor: 0.950980392, id: "eco" },
  { name: "normal", factor: 1, id: "normal" },
  { name: "sportlich", factor: 1.110687023, id: "sport" },
];

export const cityFactor = 0.0108097;
export const roadFactor = 0.0102823;
export const highwayFactor = 0.0077472;

// hard-coded value equal to setting 33%-33%-33% roads
export const defaultRoadsEfficacy = 1.0404527184574064;
